<template>
    <v-content>
        <v-breadcrumbs :items="snackbar.breadcrumbsItems" large></v-breadcrumbs>


        <v-row>
            <v-col  cols="12"
                    sm="4"
                    md="3"
                    xl="2"
                   v-for="title in snackbar.dashboardItems"
                   v-bind:key="title.link"
                   class="viewCard">

                <router-link :to="title.link">

                    <v-card class="mx-auto"
                            height="150"
                            width="300">
                        <v-img class="white--text align-end"
                               height="150"
                               :src="title.url">
                            <v-list-item three-line link>
                                <v-list-item-content>
                                    <v-list-item-content>
                                        <v-list-item-title class="white--text subtitle-1 mt-1 pa-4">
                                            {{title.name}}
                                        </v-list-item-title>
                                        <v-list-item-subtitle class="white--text header-6 mt-1">
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item-content>
                             </v-list-item>
                        </v-img>
                    </v-card>
                </router-link>
            </v-col>



        </v-row>
    </v-content>
</template>

<script>
    /*import CompanyDashboardMenu from "./CompanyDashboardMenu";*/
    import axios from "axios";

    export default {
        name: "CompanySettings",
        data() {
            return {
                snackbar: {
                    formModal: false,
                    color: '',
                    snackbar: false,
                    text: '',
                    timeout: 6000,
                    drawer: null,
                    drawerRight: null,
                    right: false,
                    dashboardItems: [
                        {
                            name: "Profile",
                            link: "/branch",
                            url: "https://cdn.vuetifyjs.com/images/cards/docks.jpg"
                        },
                        {
                            name: "Companies",
                            link: "/CompanyList",
                            url: "https://cdn.vuetifyjs.com/images/cards/docks.jpg"
                        },
                        {
                            name: "Reports",
                            link: { name: 'ReportSetting'},
                            subHeader: {},
                            url: "https://cdn.vuetifyjs.com/images/cards/docks.jpg"
                        },
                    ],
                    breadcrumbsItems: [
                        {
                            text: "Dashboard",
                            disabled: true,
                            to: "/dashboard",
                            exact: true
                        }],
                },
                customerData: {
                    updateItem: {}
                },
                branchInformation: [],
            }
        },
        methods: {
            clickEvent(route) {
                this.$router.push({name: route})
            },
            addFormModal(route) {
                this.snackbar.formModal = true
                this.dynamicComponent.current = route
            },
            dialogueClose() {
                this.customerData.updateItem = {}
                this.snackbar.formModal = false
            },
            formResponse(responseObj) {
                this.snackbar.color = responseObj.status ? 'success' : 'red'
                this.snackbar.text = responseObj.text
                this.snackbar.snackbar = true
            },
            openDrawer() {
                this.snackbar.drawerRight = !this.snackbar.drawerRight
            },
            async dashboardData() {
                const dashboardData = await axios.get(
                    "Branch/GetBranchInformationByBranchID"
                );
                this.branchInformation = dashboardData.data;
            }
        },
        mounted() {
            this.dashboardData()
        },
        components: {
            /* 'menu-list': CompanyDashboardMenu,*/
            /*// eslint-disable-next-line vue/no-unused-components
            'CompanyForm': () => import(/!* webpackChunkName: "CompanyForm" *!/ '../company/airDestination/CompanyForm'),
            // eslint-disable-next-line vue/no-unused-components
            'SectionsForm': () => import(/!* webpackChunkName: "SectionsForm" *!/ '../company/Sections/SectionsForm'),
            // eslint-disable-next-line vue/no-unused-components
            'PeriodicBudgetForm': () => import(/!* webpackChunkName: "PeriodicBudgetForm" *!/ '../company/PeriodicBudget/PeriodicBudgetForm'),
            // eslint-disable-next-line vue/no-unused-components
            'CustomerForm': () => import(/!* webpackChunkName: "CustomerForm" *!/ '../company/customer/CustomerForm')*/
        }
    }
</script>

<style scoped lang="scss">
    .options {
        border: 2px solid white;
    }

</style>
